import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { ButtonPrimary } from "src/UI/ButtonPrimary";
import { ButtonSecondary } from "src/UI/ButtonSecondary";
import { ButtonTertiary } from "src/UI/ButtonTertiary";
import { WizardFooterRow } from "../style";

interface WizardFooterSecondaryAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface WizardFooterProps {
  resetLabel: string;
  nextLabel: string;
  backLabel?: string;
  onReset: () => void;
  onNext: () => void;
  onBack?: () => void;
  showBack?: boolean;
  showReset?: boolean;
  showNext?: boolean;
  nextDisabled?: boolean;
  secondaryAction?: WizardFooterSecondaryAction;
  isCompleting?: boolean;
}

const WizardFooter: React.FC<WizardFooterProps> = ({
  resetLabel,
  nextLabel,
  backLabel,
  onReset,
  onNext,
  onBack,
  showBack = false,
  showReset = true,
  showNext = true,
  nextDisabled = false,
  secondaryAction,
  isCompleting = false,
}) => {
  return (
    <WizardFooterRow>
      {showBack && backLabel && (
        <ButtonSecondary size="md" onClick={onBack} disabled={isCompleting}>
          {backLabel}
        </ButtonSecondary>
      )}
      <Box sx={{ flex: 1 }} />
      {showReset && (
        <ButtonTertiary size="md" onClick={onReset} disabled={isCompleting}>
          {resetLabel}
        </ButtonTertiary>
      )}
      {secondaryAction && (
        <ButtonSecondary
          size="md"
          onClick={secondaryAction.onClick}
          disabled={secondaryAction.disabled || isCompleting}
        >
          {secondaryAction.label}
        </ButtonSecondary>
      )}
      {showNext && (
        <ButtonPrimary
          size="md"
          onClick={onNext}
          disabled={isCompleting || nextDisabled}
          endIcon={
            isCompleting ? (
              <CircularProgress size={16} sx={{ color: "inherit" }} />
            ) : undefined
          }
        >
          {nextLabel}
        </ButtonPrimary>
      )}
    </WizardFooterRow>
  );
};

export default WizardFooter;
